module.exports = "https://r.nearpod.com/assets/media/image/mp-icon-8f24009071228bfebcccd0411268caba.svg";